import React, { useEffect } from "react";
import TicketNumberDefault from "sub_components/Common/TicketNumberDefault";
import { object, string } from "prop-types";
import styled from "styled-components";

const ConfirmationStyle = styled.div`
  .ticket-number {
    width: auto;
    height: auto;
    svg {
      width: 300px;
      height: 200px;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    .ticket-number-wrapper {
      width: 200px;
      height: 215px;
      .ticket-number {
        width: auto;
        height: auto;
        svg {
          width: 420px;
          height: 300px;
        }
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    .ticket-confirmation-stage {
      text {
        font-size: 40px;
      }
    }
    .ticket-number-wrapper {
      width: 400px;
      height: 360px;
      .ticket-number {
        width: auto;
        height: auto;
        svg {
          width: 615px;
          height: 400px;
        }
      }
    }
  }
`;

export const ConfirmationScreen = ({
  caseId,
  navigate,
  resetModal,
  updateTickets,
}) => {
  useEffect(() => {
    if (updateTickets) {
      updateTickets();
    }
    setTimeout(() => {
      try {
        const ticket = document.getElementById("ticket-confirmation-stage");
        const ticketConfirmation = document.getElementById(
          "prefix__Gradient_Ticket_Fill-2"
        );

        document.getElementById("ticket-confirmation-trans").beginElement();
        ticketConfirmation.classList.add("active");
        if (ticket) {
          ticket.classList.add("active");
        }
      } catch (e) {
        console.log(e);
      }
    }, 500);
    setTimeout(() => {
      resetModal();
    }, 4000);
  }, []);

  return (
    <ConfirmationStyle>
      <div className="ticket-confirmation-stage" id="ticket-confirmation-stage">
        <div className="ticket-number-wrapper">
          <div
            className="ticket-number"
            onClick={
              caseId &&
              function goTo() {
                navigate(`/portal/support/ticket_history/support/${caseId}`);
              }
            }
          >
            <TicketNumberDefault number={caseId} />
          </div>
        </div>
      </div>
    </ConfirmationStyle>
  );
};
ConfirmationScreen.propTypes = {
  caseId: string.isRequired,
  navigate: object.isRequired,
  resetModal: object.isRequired,
};

ConfirmationScreen.defaultProps = {};
